import { C } from "../../styles/theme";
import { CLIENTS } from "../../data/initialData";

export default function ClientMarquee() {
  const items = [...CLIENTS, ...CLIENTS];
  return (
    <div style={{ background: "#fff", borderTop: `1px solid ${C.border}`, borderBottom: `1px solid ${C.border}`, padding: "14px 0", overflow: "hidden" }}>
      <div style={{ fontSize: 11, fontWeight: 700, color: C.gray, textAlign: "center", letterSpacing: 1, textTransform: "uppercase", marginBottom: 10 }}>Trusted by Leading Companies Across India</div>
      <div style={{ display: "flex", animation: "tk 32s linear infinite", width: "max-content" }}>
        {items.map((c, i) => (
          <div key={i} style={{ display: "inline-flex", alignItems: "center", gap: 7, padding: "4px 28px", borderRight: `1px solid ${C.border}`, flexShrink: 0 }}>
            <span style={{ fontSize: 18 }}>{c.ic}</span>
            <span style={{ fontSize: 13, fontWeight: 600, color: C.dark, whiteSpace: "nowrap" }}>{c.name}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
